// @flow
import { ACTIONS } from '../constants';
import setNotificationSetting from '../api/setNotificationSetting';

const setNotificationSettingEmail = (
    key: string,
    enabled: boolean,
    token: string
) => (dispatch: Function) => {
    setNotificationSetting(key, enabled, token);

    dispatch({
        type: ACTIONS.NOTIFICATION_SETTINGS_SET_EMAIL,
        key,
        enabled
    });
};

export default setNotificationSettingEmail;
